"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Iframe = exports.Wrapper = void 0;
const building_blocks_ui_common_1 = require("@acko-tech/building-blocks.ui.common");
exports.Wrapper = building_blocks_ui_common_1.styled.div `
  max-width: 760px;
  min-width: 560px;
  width: 100%;
  height: 100%;
  max-height: 360px;

  @media (max-width: 760px) {
    width: 100%;
    min-width: 360px;
    max-width: 100%;
  }
  ${(props) => props.styles}
`;
exports.Iframe = building_blocks_ui_common_1.styled.iframe `
  width: 100%;
  height: 100%;
  border: none;
`;
//# sourceMappingURL=component-styles.js.map